import React from 'react'

function CreateFaq() {
    return (
        <div>CreateFaq</div>
    )
}

export default CreateFaq